// Package imports:
import React from 'react';
// Component imports:
import Entrypoint from '../Entrypoint';
import ViewPepCompanyWatchReport from '../../components/PEP/ViewPepCompanyWatchReport';

interface IViewReport {
    id: string
}

const ViewPepCompanyWatchReportEntry: React.FC<IViewReport> = ({ id }) => {
    return (
        <Entrypoint>
            <ViewPepCompanyWatchReport id={id} />
        </Entrypoint>
    );
}

export default ViewPepCompanyWatchReportEntry;
